import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Youtube, Instagram, Linkedin, MapPin, Mail, Clock, DollarSign } from "lucide-react";
import { brand, contact, footerIntro, ourDifferenceQuote, footerLinks } from "../data/siteData";

const Footer = () => {
  return (
    <footer className="bg-p3-navy text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center gap-3 mb-4">
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-14 w-auto object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <span className="font-heading font-bold text-lg leading-tight">
              Prime Path<br />Partners
            </span>
          </Link>
          <p className="text-sm text-white/70 leading-relaxed max-w-md">{footerIntro}</p>
          <div className="flex items-center gap-4 mt-5">
            <span aria-disabled="true" title="Coming soon" className="text-white/30 cursor-not-allowed">
              <Facebook size={18} />
            </span>
            <span aria-disabled="true" title="Coming soon" className="text-white/30 cursor-not-allowed">
              <Youtube size={18} />
            </span>
            <span aria-disabled="true" title="Coming soon" className="text-white/30 cursor-not-allowed">
              <Instagram size={18} />
            </span>
            <span aria-disabled="true" title="Coming soon" className="text-white/30 cursor-not-allowed">
              <Linkedin size={18} />
            </span>
            <Link
              to="/how-to-order"
              title="How to Order (Bitcoin Payment Instructions)"
              className="text-p3-gold hover:text-white transition-colors"
            >
              <DollarSign size={18} />
            </Link>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-wide text-p3-gold mb-4">{ourDifferenceQuote.title}</h4>
          <ul className="space-y-2">
            {footerLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.href} className="text-sm text-white/70 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-bold uppercase tracking-wide text-p3-gold mb-4">Contact</h4>
          <p className="flex items-start gap-2 text-sm text-white/70">
            <MapPin size={16} className="mt-0.5 shrink-0 text-p3-gold" /> {contact.address}
          </p>
          <p className="flex items-center gap-2 text-sm text-white/70">
            <Mail size={16} className="shrink-0 text-p3-gold" /> {contact.email}
          </p>
          <p className="flex items-start gap-2 text-sm text-white/70 pt-2">
            <Clock size={16} className="mt-0.5 shrink-0 text-p3-gold" /> Working Hours: {contact.hours}
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Prime Path Partners. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/terms-conditions" className="text-xs text-white/60 hover:text-white transition-colors">Terms &amp; Conditions</Link>
            <Link to="/privacy-policy" className="text-xs text-white/60 hover:text-white transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
